import React, {Component} from 'react';
import {Col, Form, Row} from 'react-bootstrap'
import {
    Department,
    Email, Flag,
    JobTitle,
    Mobile,
    Name,
    Website
} from "../Redux/action";
import {connect} from 'react-redux'
import AiYearLogoToggle from './AiYearLogoToggle';


class EnglishForm extends Component {

    handleFlag = () => {
        if (this.props.name === ''&& this.props.email === '' && this.props.jobTitle === '' &&
            this.props.department === '' && this.props.mobile === '' && this.props.website === ''&&
            this.props.linkedin === '' && this.props.facebook === '' && this.props.twitter === '' &&
            this.props.github === '') {
            this.props.flag(false)
        }
    }


    async setNameValue(event) {
        event.persist();
        await this.props.en_name(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)
    }

    async setEmailValue(event) {
        event.persist();
        await this.props.en_email(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }

    async setJobTitleValue(event) {
        event.persist();
        await this.props.en_jobTitle(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)
    }

    async setDepartmentValue(event) {
        event.persist();
        await this.props.en_department(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }

    async setMobileValue(event) {
        event.persist();
        await this.props.en_mobile(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }

    async setWebsiteValue(event) {
        event.persist();
        await this.props.en_website(event.target.value)
        if (event.target.value === '') {
            this.handleFlag();
        } else
            this.props.flag(true)

    }


    render() {
        return (
            <Form className="mt-sm-1 justify p-1 border-0 "  style={{direction: "ltr",textAlign:"left"}}>
                <Row>
                    <Col lg="6">
                        <Form.Group as={Row} name="formPlaintextName">
                            <Form.Label column sm="12">
                                Full Name
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="text" name="name" value={this.props.name} onChange={this.setNameValue.bind(this)} placeholder="Mohammed Abdullah"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="6">
                        <Form.Group as={Row} name="formPlaintextJobTitle">
                            <Form.Label column sm="12">
                                Job Title
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="text" name="jobTitle" value={this.props.jobTitle} onChange={this.setJobTitleValue.bind(this)} placeholder="Job Title"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="6">
                        <Form.Group as={Row} name="formPlaintextDepartment">
                            <Form.Label column sm="12">
                                Department
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="text" name="department" value={this.props.department} onChange={this.setDepartmentValue.bind(this)}
                                            placeholder="Department"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="6">
                        <Form.Group as={Row} name="formPlaintextMobile">
                            <Form.Label column sm="12">
                                Phone
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="tel" name="mobile" value={this.props.mobile} onChange={this.setMobileValue.bind(this)} placeholder="011 / 055"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="12">
                        <Form.Group as={Row} name="formPlaintextEmail">
                            <Form.Label column sm="12">
                                Email
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="email" value={this.props.email} name="email" onChange={this.setEmailValue.bind(this)}
                                            placeholder="m.abdullah@ksu.edu.sa"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="12">
                        <Form.Group as={Row} name="formPlaintextWebsite">
                            <Form.Label column sm="12">
                                Website
                            </Form.Label>
                            <Col sm="12">
                                <Form.Control type="url" name="website" value={this.props.website} onChange={this.setWebsiteValue.bind(this)}
                                            placeholder="https://ksu.edu.sa/ar"/>
                            </Col>
                        </Form.Group>
                    </Col>
                    <Col lg="12">
                        <AiYearLogoToggle/>
                    </Col>
                </Row>
            </Form>

        );
    }
}


function mapStateToProps(state) {
    return {
            name: state.reducer.name,
            email: state.reducer.email,
            jobTitle: state.reducer.jobTitle,
            department: state.reducer.department,
            mobile: state.reducer.mobile,
            website: state.reducer.website,
            linkedin: state.socialReducer.linkedin,
            twitter: state.socialReducer.twitter,
            facebook: state.socialReducer.facebook,
            github: state.socialReducer.github,
        }

}

function mapDispatchToProps(dispatch) {
    return {
        flag: (flag) => dispatch(Flag(flag)),
        en_name: (name) => dispatch(Name(name)),
        en_email: (email) => dispatch(Email(email)),
        en_jobTitle: (job) => dispatch(JobTitle(job)),
        en_department: (department) => dispatch(Department(department)),
        en_mobile: (mobile) => dispatch(Mobile(mobile)),
        en_website: (website) => dispatch(Website(website)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(EnglishForm);
